import createPersistedState from 'vuex-persistedstate'

export default ({ store, $config }) => {
  createPersistedState({
    key: $config.persistedStateKey,
    paths: ['user', 'cart', 'transact', 'auth', 'accessRequests'],
  })(store)
}
